module.exports = __webpack_public_path__ + "assets/322a0300602be7dfc93fee102f78877d.svg";